module.exports = __webpack_public_path__ + "static/supplierbg3-89dc91b0d4027cfced756ee4ee812bdd.jpg";